import { MemberAnnuityOrderItemDto } from "./../../shared/service-proxies/service-proxies";
import {
    ICart,
    IMemberAnnuityCart,
} from "./../../app/store/cart/cart-helper-service";
import {
    Component,
    ElementRef,
    Injector,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CartHelperService } from "@app/store/cart/cart-helper-service";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/common/app-component-base";
import {
    AnnuitiesServiceProxy,
    AnnuityCategoryDeadlineDto,
    AnnuityEditDto,
    CategoryServiceProxy,
    CreateOrEditMemberAnnuityDto,
    MemberAnnuityDto,
    MemberAnnuityServiceProxy,
    MemberAnnuityUserEditDto,
    PaymentDto,
    PaymentMethod,
    RegistrationsServiceProxy,
    UpdateMemberAnnuityValuesInput,
    UserSelectListDto,
    UserServiceProxy,
} from "@shared/service-proxies/service-proxies";
import * as moment from "moment";
import * as _ from "lodash";

@Component({
    selector: "app-join-anuuity",
    templateUrl: "./join-anuuity.component.html",
    styleUrls: [
        "./join-anuuity.component.css",
        "../shared/common/styles/congress.css",
    ],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
})
export class JoinAnuuityComponent extends AppComponentBase implements OnInit {
    @ViewChild("btnmore") btnmore: ElementRef;

    userLoaded = false;
    saving = false;

    annuityId: number;
    paidAnnuity = false;
    userId: number;
    memberAnnuityId: number = 0;
    onLocal = false;
    year = moment().year();

    annuity = undefined;
    memberAnnuity = new CreateOrEditMemberAnnuityDto();
    userLogged = this.appSession.user;
    memberCategory = undefined;
    categoryLevelId = undefined;
    userToPayment = undefined;
    categoryDeadline: AnnuityCategoryDeadlineDto = undefined;
    cart: ICart = undefined;
    creditCardPayment: any;
    paymentMethodSelected: any;
    inBag = false;

    categories = [];
    cartItems = [];
    eventTypes = [];

    constructor(
        injector: Injector,
        private route: ActivatedRoute,
        private _memberAnnuityService: MemberAnnuityServiceProxy,
        private _annuitiesService: AnnuitiesServiceProxy,
        private _userService: UserServiceProxy,
        private _registrationsService: RegistrationsServiceProxy,
        private _categoryService: CategoryServiceProxy,
        private _cartHelperService: CartHelperService,
        private activatedRoute: ActivatedRoute,
        private _router: Router
    ) {
        super(injector);
    }

    ngOnInit() {
        this.registerToEvents();
        this.route.queryParams.subscribe((params: Params) => {
            this.annuityId = +params["annuityId"];
            this.userId = +params["userId"];
            this.memberAnnuityId = params["memberAnnuityId"]
                ? +params["memberAnnuityId"]
                : 0;
        });

        this.cart = this._cartHelperService.getCart();
        this.loadCategories();
        this.loadMemberAnnuity();
        if (localStorage.getItem("event-types")){
            this.eventTypes = JSON.parse(localStorage.getItem("event-types")) as Array<string>;
            this.eventTypes = this.eventTypes.length > 2 ? this.eventTypes.sort().slice(0, 3) : this.eventTypes.sort();
        }
    }

    registerToEvents() {
        abp.event.on("app.cart.refresh", () => {
            this.checkAllBagItems();
        });
    }

    loadCategories() {
        this._categoryService
            .getForSelect("", undefined, true, false)
            .subscribe((result) => {
                this.categories = result.items;
            });
    }

    loadMemberAnnuity(): void {
        if (!this.userId) {
            this.userId = abp.session.userId;
        }

        this.loadCurrentAnnuity();
    }

    loadCurrentAnnuity(): void {
        this._annuitiesService
            .getAnnuitiesForSelect(this.year.toString(), undefined)
            .subscribe((result) => {
                if (result && result.items.length > 0) {
                    this.annuityId = result.items[0].id;
                    this.checkAllBagItems();
                    this.loadAnnuity();
                }
            });
    }

    loadAnnuity() {
        this._annuitiesService
            .getAnnuityForPayment(this.annuityId)
            .subscribe((result) => {
                this.annuity = result;

                if (this.memberAnnuityId > 0) {
                    this.loadSavedMemberAnnuity();
                } else if (this.cart.memberAnnuities.length > 0) {
                    let memberAnnuityCart =
                        this._cartHelperService.getMemberAnnuity(
                            this.annuityId
                        );

                    if (memberAnnuityCart) {
                        this.userId = this.cart.user.id;
                        this.categoryDeadline =
                            memberAnnuityCart.categoryDeadline;
                        this.categoryDeadline.deadline = moment(
                            this.categoryDeadline.deadline
                        );

                        this.loadUserCart();

                        this.memberAnnuity.annuity.categoryDeadLineId =
                            this.categoryDeadline.id;

                        this.annuity.categoryDeadlines.forEach(
                            (categoryDeadlineSelected) => {
                                if (
                                    categoryDeadlineSelected.id ==
                                    this.memberAnnuity.annuity
                                        .categoryDeadLineId
                                ) {
                                    this.categoryDeadline =
                                        categoryDeadlineSelected;
                                }
                            }
                        );

                        this.calculateValue();
                    }
                } else if (this.cart.user) {
                    this.loadUserCart();
                } else {
                    this.loadUserForPayment();
                }
            });
    }

    loadSavedMemberAnnuity() {
        this._memberAnnuityService
            .getMemberAnnuityForEdit(this.memberAnnuityId)
            .subscribe((result) => {
                if (result.memberAnnuity) {
                    result.memberAnnuity.user.emails = undefined;
                    result.memberAnnuity.user.phones = [];
                    result.memberAnnuity.user.address = undefined;
                    this.memberAnnuity = result.memberAnnuity;

                    //TODO: Pagamento no checkout
                    //   if (result.memberAnnuity.annuity.payments.length > 0) {

                    //     this.memberAnnuity.annuity.paymentMethodPermissions.forEach(paymentMethodPermission => {

                    //       if (paymentMethodPermission.id == result.memberAnnuity.annuity.payments[0].paymentMethodId) {
                    //         this.paymentMethodSelected = paymentMethodPermission;
                    //       }
                    //     });
                    //   }
                    this.loadUserForPayment();
                }
            });
    }

    loadUserCart(): void {
        this.userId = this.cart.user.id;

        this.userToPayment = new UserSelectListDto();
        this.userToPayment.id = this.cart.user.id;
        this.userToPayment.name = this.cart.user.name;

        let user = new MemberAnnuityUserEditDto();
        user.id = this.cart.user.id;
        user.name = this.cart.user.name;
        user.nameForCredential = this.cart.user.nameForCredential;
        user.userName = this.cart.user.userName;
        user.emailAddress = this.cart.user.emailAddress;
        user.address = this.cart.user.address;
        user.emails = this.cart.user.emails;
        user.phones = this.cart.user.phones;

        this.memberAnnuity = new CreateOrEditMemberAnnuityDto();
        this.memberAnnuity.user = user;
        this.memberAnnuity.annuity = new MemberAnnuityDto();
        this.memberAnnuity.annuity.annuityId = this.annuityId;

        if (!this.cart.user.id) {
            this.categories.forEach((category) => {
                if (
                    category.id ==
                    this.cart.user.member.categories[0].categoryId
                )
                    this.memberCategory = category;
            });
            this.categoryLevelId =
                this.cart.user.member.categories[0].categoryLevelId;
            this.userLoaded = true;
        } else this.loadUserForPayment(true);
    }

    checkAllBagItems() {
        this.cart = this._cartHelperService.getCart(this.onLocal);

        if (this.cart && this.cart.memberAnnuities) {
            this.cartItems = this.cart.memberAnnuities;

            this.inBag =
                this.cartItems.filter(
                    (x) => x.memberAnnuity.annuityId == this.annuityId
                ).length > 0;
        }
    }

    //Check bag items
    checkBagItems(annuityId: number): boolean {
        this.cartItems = this.cart.memberAnnuities;
        return (
            this.cartItems.filter((x) => x.memberAnnuity.annuityId == annuityId)
                .length > 0
        );
    }

    addToBag(): void {
        this.saving = true;

        this.memberAnnuity.annuity.payments = [];
        this.memberAnnuity.annuity.payments.push(this.memberAnnuity.payment);

        let annuityItem = new AnnuityEditDto();
        annuityItem.year = this.annuity.year;

        let item: IMemberAnnuityCart = {
            memberAnnuity: this.memberAnnuity.annuity,
            categoryDeadline: this.categoryDeadline,
            annuity: annuityItem,
        };

        this._cartHelperService.addMemberAnnuityToCart(item);

        abp.event.trigger("app.cart.refresh");
        this.cart = this._cartHelperService.getCart(this.onLocal);
    }

    //Remove item from bag
    removeFromBag(annuityId: number) {
        this._cartHelperService.removeMemberAnnuityById(annuityId);

        this._cartHelperService.updateUserCart(this.memberAnnuity.user, false);

        abp.event.trigger("app.cart.refresh");
        this.cart = this._cartHelperService.getCart(this.onLocal);
    }

    loadUserForPayment(onlyCheckPaidAnnuity?: boolean): void {
        if (
            this.memberAnnuity &&
            this.memberAnnuity.user &&
            onlyCheckPaidAnnuity == undefined
        ) {
            this.memberAnnuity.user.emails = undefined;
            this.memberAnnuity.user.phones = [];
            this.memberAnnuity.user.address = undefined;
            this.userLoaded = true;
        }

        this._registrationsService
            .getUserForRegistration(this.userId, undefined, this.annuityId)
            .subscribe((result) => {
                this.userLoaded = true;
                this.paidAnnuity = result.paidAnnuity;

                this.setCategoryDeadline(
                    result.categoryId,
                    result.itsReadmissionAnnuity
                );

                if (onlyCheckPaidAnnuity == undefined) {
                    let user = new MemberAnnuityUserEditDto();
                    user.id = result.id;
                    user.userName = result.userName;
                    user.name = result.name;
                    user.nameForCredential = result.nameForCredential;
                    user.emailAddress = result.emailAddress;
                    user.emails = result.emails;
                    user.phones = result.phones;
                    user.address = result.address;

                    let annuity = new MemberAnnuityDto();
                    annuity.annuityId = this.annuityId;
                    annuity.id = this.memberAnnuityId;

                    this.memberAnnuity = new CreateOrEditMemberAnnuityDto();
                    this.memberAnnuity.user = user;
                    this.memberAnnuity.annuity = annuity;

                    this._cartHelperService.updateUserCart(user, false);
                    this.cart = this._cartHelperService.getCart(this.onLocal);
                    abp.event.trigger("app.cart.refresh");

                    //this.adjustUser();
                }

                if (this.categoryDeadline) this.calculateValue();
            });
    }

    setCategoryDeadline(categoryId: number, itsReadmission: boolean): void {
        let deadLines = _.filter(this.annuity.categoryDeadlines, {
            categoryId: categoryId,
            itsReadmission: itsReadmission,
        } as AnnuityCategoryDeadlineDto);

        if (deadLines.length > 0) {
            this.categoryDeadline = deadLines[0];
        }
    }

    calculateValue(): void {
        if (this.categoryDeadline) {
            this.memberAnnuity.annuity.categoryDeadLineId =
                this.categoryDeadline.id;
            this.memberAnnuity.annuity.categoryDeadLine = this.categoryDeadline;

            if (!this.memberAnnuity.payment) {
                this.memberAnnuity.payment = new PaymentDto();
                this.memberAnnuity.payment.paidDate = moment();
            }
            // else this.creditCardPayment.creditCardBrand = undefined;

            this.memberAnnuity.payment.paymentMethodId = this
                .paymentMethodSelected
                ? this.paymentMethodSelected.paymentMethodId
                : undefined;

            let updateValuesInput = new UpdateMemberAnnuityValuesInput();
            updateValuesInput.userName = this.memberAnnuity.user.userName;
            updateValuesInput.annuity = this.memberAnnuity.annuity;
            updateValuesInput.payment = this.memberAnnuity.payment;
            updateValuesInput.creditCardPayment =
                this.memberAnnuity.creditCardPayment;
            updateValuesInput.debitCardPayment =
                this.memberAnnuity.debitCardPayment;
            updateValuesInput.ticketPayment = this.memberAnnuity.ticketPayment;

            this._memberAnnuityService
                .updateValues(updateValuesInput)
                .subscribe((result) => {
                    this.memberAnnuity.payment = result;
                });
        }
    }

    goToRoute(route: string, type?: string) {
        this.triggerFalseClick();
        this._router.navigate([route + type]);
    }

    triggerFalseClick() {
        let el: HTMLElement = this.btnmore.nativeElement;
        el.click();
    }
}



// WEBPACK FOOTER //
// ./src/congress/join-anuuity/join-anuuity.component.ts